module.exports = __webpack_public_path__ + "img/logo-white.323ef7b1.png";